export class CDragObject {
    public m_mc:fgui.GMovieClip;
    public m_origx:number;
    public m_origy:number;
    public m_sx:number;
    public m_sy:number;
    public m_ofsx:number;
    public m_ofsy:number;
    public m_MouseDown:boolean;
}